import { Tabs } from "antd";
import ContentLayout from "../components/layout/ContentLayout";
import CardDeletionsTab from "../components/CardDeletionTab";
import CardApprovalsTab from "../components/CardApprovalsTab";

export default function Stampcards() {
  return (
    <ContentLayout
      header={
        <h1>
          Magic <span>Stamp Cards</span>
        </h1>
      }
    >
      <Tabs defaultActiveKey="1">
        <Tabs.TabPane tab="Deletions" key="1">
          <CardDeletionsTab />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Approvals / Rejections" key="2">
          <CardApprovalsTab />
        </Tabs.TabPane>
      </Tabs>
    </ContentLayout>
  );
}
